import { RestaurantPreparationStationDTO } from '../../../../types/restaurant/RestaurantPreparationStationTypes';

import PreparationStationCard from './PreparationStationCard';

interface PreparationStationGridProps {
  stations: RestaurantPreparationStationDTO[];
  onEdit: (station: RestaurantPreparationStationDTO) => void;
  onDeactivate: (station: RestaurantPreparationStationDTO) => void;
  onManageAssignments: (station: RestaurantPreparationStationDTO) => void;
}

const PreparationStationGrid = ({
  stations,
  onEdit,
  onDeactivate,
  onManageAssignments,
}: PreparationStationGridProps) => {
  return (
    <div className="grid grid-cols-1 gap-4 p-5 md:hidden">
      {stations.map((station) => (
        <PreparationStationCard
          key={station.id}
          station={station}
          onEdit={onEdit}
          onDeactivate={onDeactivate}
          onManageAssignments={onManageAssignments}
        />
      ))}
    </div>
  );
};

export default PreparationStationGrid;
